import React from 'react';
import { TranslationKeys } from '../../../enums';
import ImgPGLogo from '../../../assets/images/p-g-logo.svg';

const LiveBetsLoading = ({ t }) => {
  return (
    <div className='dr-wheel-loader-wrp'>
      <div className='dr-wheel-loader-img-wrp'>
        <img src={ImgPGLogo} alt='pg' />
      </div>
      <p className='dr-wheel-loader-content-text'>{t(TranslationKeys.LoaderText)}</p>
      <div className='dr-wheel-loader-content'>
        <span className='dr-wheel-loader-circle' />
        <span className='dr-wheel-loader-circle' />
        <span className='dr-wheel-loader-circle' />
      </div>
    </div>
  );
};

export default LiveBetsLoading;
